// Excel for Windows limits the complete file path to 218 characters. Keeping
// the basename at 120 leaves room for the user's Downloads/OneDrive folders
// and the .xlsx extension.
export const MAX_BUNDLE_PLAN_FILENAME_LENGTH = 120;

export const truncateBundlePlanFilename = filename => {
  if (!filename || filename.length <= MAX_BUNDLE_PLAN_FILENAME_LENGTH) return filename;
  return filename.substring(0, MAX_BUNDLE_PLAN_FILENAME_LENGTH);
};
